import { DialogContent, DialogTitle } from "@mui/material";
import { Form } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormTypes } from "../../../../../actions/forms";
import { getUserRoles } from "../../../../../actions/users";
import CustomDialog from "../../../../commons/dialog/customDialog";
import FormikActions from "../../../../commons/formik/formikActions";
import FormikForm from "../../../../commons/formik/formikForm";
import { StyledDialog } from "../../../../styled/dialog";
import FormConfigurationForm from "./formConfigurationForm";
import { formConfigurationFormValidationSchema } from "./validations";

const initialValues = {
  idArt: "",
  idRol: "",
  idFormulario: null,
  ver: false,
  crear: false,
  editar: false,
  borrar: false,
}


const FormConfigurationFormContainer = ({
  open,
  handleClose,
  handleSubmit,
  loading,
  formConfigurationToEdit,
  editingRole, // This prop indicates if we are editing all forms in role or for only one form
}) => {
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.users.roles.data);
  const formTypes = useSelector((state) => state.forms.getFormTypes.data);
  const [internalLoading, setInternalLoading] = useState(true);
  const [formInitialValues, setFormInitialValues] = useState(initialValues);

  useEffect(() => {
    if (!open) return;

    setInternalLoading(true);

    if (formConfigurationToEdit) {
      setFormInitialValues({
        idRol: formConfigurationToEdit.idRol,
        idArt: formConfigurationToEdit.idArt,
        idFormulario: formConfigurationToEdit.idFormulario,
        ver: formConfigurationToEdit.ver ?? true,
        crear: formConfigurationToEdit.crear ?? true,
        editar: formConfigurationToEdit.editar ?? true,
        borrar: formConfigurationToEdit.borrar ?? true,
      });
    } else {
      setFormInitialValues(initialValues);
    }

    const rolesPromise = roles.length === 0 ? dispatch(getUserRoles()) : Promise.resolve();
    const formTypesPromise = formTypes.length === 0 ? dispatch(getFormTypes()) : Promise.resolve();

    Promise.all([rolesPromise, formTypesPromise]).finally(() => {
      setInternalLoading(false);
    });

  }, [formConfigurationToEdit, open])

  useEffect(() => {
    if (!open) {
      setInternalLoading(true);
    }
  }, [open])

  return (
    <>
      <CustomDialog
        open={open}
        onClose={handleClose}
        scroll="paper"
      >
        <DialogTitle>
          {"Permisos Formulario Rol"}
        </DialogTitle>
        <FormikForm
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={() => formConfigurationFormValidationSchema(editingRole)}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <DialogContent >
                <StyledDialog.Container>
                  <FormConfigurationForm
                    loading={internalLoading || loading}
                    editing={!!formConfigurationToEdit}
                    editingRole={editingRole}
                  />
                </StyledDialog.Container>
              </DialogContent>
              <StyledDialog.Actions>
                <FormikActions
                  handleCancel={handleClose}
                  submitText="Aceptar"
                  disabled={internalLoading || loading}
                />
              </StyledDialog.Actions>
            </Form>
          )}
        </FormikForm>
      </CustomDialog>
    </>

  )
}

export default FormConfigurationFormContainer;